// @flow

import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import { WebsiteDefaultPage as BaseWebsiteDefaultPage } from 'components/Page';
import { PageType } from 'Constants';
import { OriginationFees } from 'data/global/footer/legal/numbered';
import { useImages } from 'hooks';
import { flex, Layout, maxWidthContainer, topBottomMargin, Width } from 'styles';
import { MarketsHero, ResourcesSideBar } from 'components/Content';

const METADATA = {
  title: 'Financial products to simplify finances, faster',
  description: `At Markets Direct, we’re transforming home equity by creating a fast, simple and transparent process to bring you closer to your financial goals. We'll show you how to use home equity to consolidate debt, pay for home improvement or fund your retirement. It's quick and easy. Let’s unlock the potential of your largest asset.`,
};

const PAGE_TYPE = {
  product: PageType.PRODUCT.NONE,
};

const WebsiteDefaultPage = styled(BaseWebsiteDefaultPage)`
  width: 100% !important;
`;

const Wrapper = styled.div`
  width: 100%;
  ${flex()};
  flex-direction: column;
  ${topBottomMargin([Layout.NAV_HEIGHT_MOBILE, 0], [Layout.NAV_HEIGHT_DESKTOP, 0], [Layout.NAV_HEIGHT_DESKTOP, 0])};
`;

const Content = styled.div`
  width: 100%;
  background: white;

  > div {
    padding: 40px 0;
    ${maxWidthContainer(1080)};
    ${flex()};
    flex-direction: column;

    @media (min-width: ${Width.BREAK_MD}px) {
      ${flex('flex-start', 'flex-start')};
      flex-direction: row;
    }
  }
`;

const Text = styled.div`
  white-space: pre-line;
`;

const PageContainer = ({ data }: { data: any }) => {
  const getImage = useImages(data);

  return (
    <WebsiteDefaultPage
      page={PAGE_TYPE}
      metaData={{
        ...METADATA,
        image: getImage('resources'),
      }}
      footerLegal={{
        numbered: OriginationFees,
      }}>
      <Wrapper>
        <MarketsHero
          title="RESOURCES"
          blurb="Hello? How can we help you?"
          image={{
            name: 'resources',
          }}
          images={data}
        />
        <Content>
          <div>
            <ResourcesSideBar sectionIndex={0} pageIndex={4}>
              <Text>
                <strong>What is Negative Balance Protection of your trading account?</strong>
                {`
                
Negative balance protection means that any trading losses cannot exceed the funds on your account and thereby giving you, the customer greater protection. Therefore, whilst you can still lose all your account funds, you cannot exceed that loss on your account which means that, in accordance with the policy below, you will not owe money to us. Please note however that your entire capital may still be at risk. Below is the policy by which Triton Capital Markets Limited shall manage and calculate the negative balance on your trading account.

1) This policy is only applicable to retail customers.

2) Triton Capital Markets Limited's systems have always incorporates the requisite safeguards to protect the customers from encountering negative balances when trading under normal market conditions. Customers are provided with margin monitoring functionality. If the margin level on customer account is equal to, or drops below, 50%, Triton Capital Markets Limited's system automatically initiates the closing of current open positions, starting from the most unprofitable taking into account trading hours of particular instruments traded by the customer. Positions will be automatically closed at the current market price. Also, the customers can and should set personal limits for risk management purposes which can help limit losses and maximize profits.

3) In the event that there are certain market conditions which cause a significant "market gap" and thereby making it possible to incur a negative balance while trading, Triton Capital Markets Limited shall absorb the negative balance. The customer shall therefore be protected against such loss because the purpose of the negative balance protection also provides a backstop in the case of extreme market conditions.

4) The customer should maintain the appropriate levels of margin in the trading account at all times as the recommended method of risk management.

`}
              </Text>
            </ResourcesSideBar>
          </div>
        </Content>
      </Wrapper>
    </WebsiteDefaultPage>
  );
};

export default PageContainer;

export const query = graphql`
  query {
    imageToWebP: allFile(filter: { relativeDirectory: { eq: "pages/resources" }, extension: { nin: ["svg", "gif"] } }) {
      edges {
        node {
          ...ImageToWebP
        }
      }
    }
    otherImage: allFile(filter: { relativeDirectory: { eq: "pages/resources" }, extension: { in: ["svg", "gif"] } }) {
      edges {
        node {
          ...OtherImage
        }
      }
    }
  }
`;
